import React from 'react'
import InputMask from 'react-input-mask';
/* COMPONENTS */
import styled from 'styled-components'


const CardWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;

    label{
        font-family: "Poppins";
        font-weight: 400;
        font-style: normal;
        margin-bottom: 0.9rem;
    }

    input{
    font-family: "Poppins";
    font-weight: 500;
    appearance: none;
    font-size: 1rem;
    color: black;
    padding-left: 0.4rem;
    width: 420px;
    height: 45px;
    border:1px solid rgb(215, 215, 215);
    outline:none;
    border-radius: 5px;
    }

    @media screen and (max-width:720px){
        width: 100%;
        
    }

`
const InputEl = styled.input`
    font-family: "Poppins";
    font-weight: 500;
    appearance: none;
    font-size: 1rem;
    color: black;
    padding-left: 0.4rem;
    width: 420px;
    height: 45px;
    border:1px solid rgb(215, 215, 215);
    outline:none;
    border-radius: 5px;

    @media screen and (max-width:720px){
        width: 100%;
        
    }


`


const Input = ({ name, onChange, type, mask, value, accept, onBlur, maxLength,placeholder }) => {
    return (
        <CardWrapper>
            <label>{name}</label>
            <InputMask maxLength={maxLength} maskChar={false} placeholder={placeholder} onChange={onChange}  accept={accept} type={type} mask={mask} value={value} onBlur={onBlur} />
        </CardWrapper>
    )
}

export default Input